import { makeAutoObservable } from 'mobx';

export default class TestTubeRack {
  hasIPTGz: boolean;
  hasIPTGa: boolean;
  hasONPGz: boolean;
  hasONPGa: boolean;

  constructor(
    hasIPTGz: boolean = false,
    hasIPTGa: boolean = false,
    hasONPGz: boolean = false,
    hasONPGa: boolean = false
  ) {
    makeAutoObservable(this);

    this.hasIPTGz = hasIPTGz;
    this.hasIPTGa = hasIPTGa;
    this.hasONPGz = hasONPGz;
    this.hasONPGa = hasONPGa;
  }

  isMatch = (testTubeRack?: TestTubeRack | null): boolean => {
    return (
      testTubeRack?.hasONPGz === this.hasONPGz &&
      testTubeRack?.hasIPTGz === this.hasIPTGz &&
      testTubeRack?.hasONPGa === this.hasONPGa &&
      testTubeRack?.hasIPTGa === this.hasIPTGa
    );
  };

  toggleHasIPTGz = () => (this.hasIPTGz = !this.hasIPTGz);
  toggleHasIPTGa = () => (this.hasIPTGa = !this.hasIPTGa);
  toggleHasONPGz = () => (this.hasONPGz = !this.hasONPGz);
  toggleHasONPGa = () => (this.hasONPGa = !this.hasONPGa);
}
